import { AxiosResponse } from 'axios';
import { csrfToken, instance } from '../db';

// 大分類マスタの取得
export const getMaterialList = async (): Promise<AxiosResponse> => {
  const response = await instance.get('/materials', {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });

  return response;
};

export const getOperatorMaterialList = async (): Promise<AxiosResponse> => {
  const response = await instance.get('/operator/materials', {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });

  return response;
};

export const createMaterial = async (
  name: string,
  value: number,
  co2Unit: string,
  costUnit: string | null | undefined,
  calculation: string | null | undefined,
  priceCondition: string | null | undefined,
  remark: string | null | undefined,
  sort: number,
  categoryId: number,
  showMessage?: number | null | undefined
): Promise<AxiosResponse> => {
  const data = {
    name: name,
    value: value,
    co2_unit: co2Unit,
    cost_unit: costUnit,
    price_condition: priceCondition,
    calculation_specification: calculation,
    remark: remark,
    sort: sort,
    category_id: categoryId,
    show_message: showMessage
  };

  const response = await instance.post('/operator/materials', data, {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });

  return response;
};

export const updateMaterial = async (
  id: number,
  name: string,
  value: number,
  co2Unit: string,
  costUnit: string | null | undefined,
  calculation: string | null | undefined,
  priceCondition: string | null | undefined,
  remark: string | null | undefined,
  sort: number,
  categoryId: number,
  showMessage?: number | null | undefined
): Promise<AxiosResponse> => {
  const data = {
    name: name,
    value: value,
    co2_unit: co2Unit,
    cost_unit: costUnit,
    price_condition: priceCondition,
    calculation_specification: calculation,
    remark: remark,
    sort: sort,
    category_id: categoryId,
    show_message: showMessage
  };

  const response = await instance.put(`/operator/materials/${id}`, data, {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });

  return response;
};
